import { qualityApiClient } from '@/shared/api/core/axios-instance';

import type { DataZoneLowerCaseString, QualityLevel, SelectedSortByValue } from '@/entities/quality';

export type TableQualityApiResponse = {
  tableId: number;
  tableName: string;
  fqn: string;
  service: string;
  dataZone: DataZoneLowerCaseString;
  namespace: string;
  statDate: string;
  totalRows: number;
  goodRows: number;
  goodRatio: number;
  poorRows: number;
  poorRatio: number;
  unknownRows: number;
  unknownRatio: number;
  incrementalRows: number;
  qualityLevel: QualityLevel;
  collectedAt: string;
};

export type TableQualityApiParams = {
  dataZone?: DataZoneLowerCaseString;
  service?: string;
  fromDate?: string;
  toDate?: string;
  tableId?: number;
  qualityLevel?: QualityLevel;
  sortBy?: SelectedSortByValue;
  page?: number;
  pageSize?: number;
};

export type TableQualityApiResult = {
  success: boolean;
  data: TableQualityApiResponse[];
  summary: {
    totalGoodRows: number;
    totalPoorRows: number;
    totalUnknownRows: number;
  };
  meta: {
    total: number;
    page: number;
    pageSize: number;
    totalPages: number;
    fromDate?: string;
    toDate?: string;
  };
};

export const getTableQualityData = async (params: TableQualityApiParams): Promise<TableQualityApiResult> => {
  const { data } = await qualityApiClient.get<TableQualityApiResult>('/stats/table-quality', { params });
  return data;
};
